export class TimeInfo {
    minuti_correnti: number = null;
    extraTime_correnti: number = null;
    stato_diretta: number = null;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/time-info.ts